var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hy-mask',{model:{value:(_vm.maskShow),callback:function ($$v) {_vm.maskShow=$$v},expression:"maskShow"}},[_c('div',[_vm._v("54444444444444555")])]),_c('button',{on:{"click":_vm.show}},[_vm._v("点击显示")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }